"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useEntityDefinitionForPluralSlug = void 0;
var react_1 = __importDefault(require("react"));
var use_entities_1 = require("./use-entities");
var lodash_1 = require("lodash");
var useEntityDefinitionForPluralSlug = function (slug) {
  var entities = (0, use_entities_1.useEntities)();
  var entitiesByPluralSlug = react_1.default.useMemo(function () {
    return (0, lodash_1.keyBy)(entities, 'pluralSlug');
  }, [entities]);
  return entitiesByPluralSlug[slug];
};
exports.useEntityDefinitionForPluralSlug = useEntityDefinitionForPluralSlug;